import { useEffect, useRef } from "react";
import { useAuiState } from "@assistant-ui/react";

export function useOnMainThreadSwitched(
  onSwitched: (nextId: string, prevId: string | undefined) => void,
  { waitForLoaded = true } = {}
) {
  const mainThreadId = useAuiState(s => s.threads.mainThreadId);
  const isLoading = useAuiState(s => s.thread.isLoading);

  const prevRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const prev = prevRef.current;

    // first render: initialize prev and bail
    if (prev === undefined) {
      prevRef.current = mainThreadId;
      return;
    }

    // id didn't change -> not a switch
    if (!mainThreadId || mainThreadId === prev) return;

    // optional: only fire once the newly selected thread is loaded
    if (waitForLoaded && isLoading) return;

    prevRef.current = mainThreadId;
    onSwitched(mainThreadId, prev);
  }, [mainThreadId, isLoading, onSwitched, waitForLoaded]);
}